export default "__VITE_ASSET__BQ0wq_GE__"